<template>
<div class="feature-box">
    <a href="##" @click.prevent>
        <div class="heading">
            {{ featureLabel[feature.type] }}
        </div>
        <div class="badge-buttons-wrapper">
            <div class="badge-buttons shadow">
                <button @click.prevent="() => showEditFeatureForm(feature.type, feature.id)"
                title="Edit"><i class="pen"></i></button>
                <button @click.prevent="() => showFeatureDeleteConfirmationModal(feature.id)"
                title="Delete"><i class="trash"></i></button>
            </div>
        </div>
        <div class="content">
            <i :class="featureClass[feature.type]"></i>
        </div>
    </a>
</div>
</template>

<script>
export default {
    props: [
        'feature',
        'showFeatureDeleteConfirmationModal',
        'showEditFeatureForm'
    ],
    data(){
        return{
            featureLabel: {
                audio: 'Audio',
                video: 'Video',
                panorama: 'Panorama',
                arObject: 'Augumented reality',
                webview: 'Webview',
                text: 'Text',
                map: 'Map',
                quiz: 'Quiz',
            },
            featureClass: {
                audio: 'ricon-headphone',
                video: 'ricon-video',
                panorama: 'ricon-room360',
                arObject: 'ricon-augmented-reality-weiss',
                webview: 'ricon-augmented-reality-weiss',
                text: 'ricon-bubble',
                map: 'ricon-location',
                quiz: 'ricon-info-question-mark',
            },
        }
    },
}
</script>
